module.exports = __webpack_public_path__ + "static/media/case3C.dcf8f09.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case3C.mp4
// module id = q14m
// module chunks = 0